import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import styled from "styled-components";
import { warning } from "@kiwicom/js";
import convertHexToRgba from "@kiwicom/orbit-design-tokens/lib/convertHexToRgba";
import defaultTheme from "../defaultTheme";
import { baseURL, CODES, SIZES, TOKENS } from "./consts";

var getSizeToken = function getSizeToken(name) {
  return function (_ref2) {
    var _TOKENS$WIDTH, _TOKENS$HEIGHT, _tokens;

    var theme = _ref2.theme,
        size = _ref2.size;
    var tokens = (_tokens = {}, _defineProperty(_tokens, TOKENS.WIDTH, (_TOKENS$WIDTH = {}, _defineProperty(_TOKENS$WIDTH, SIZES.SMALL, "16px"), _defineProperty(_TOKENS$WIDTH, SIZES.MEDIUM, theme.orbit.widthCountryFlag), _TOKENS$WIDTH)), _defineProperty(_tokens, TOKENS.HEIGHT, (_TOKENS$HEIGHT = {}, _defineProperty(_TOKENS$HEIGHT, SIZES.SMALL, "9px"), _defineProperty(_TOKENS$HEIGHT, SIZES.MEDIUM, "13px"), _TOKENS$HEIGHT)), _tokens);
    return tokens[name][size];
  };
};

var StyledCountryFlag = styled.div.withConfig({
  displayName: "CountryFlag__StyledCountryFlag",
  componentId: "h98fwe-0"
})(["position:relative;height:", ";width:", ";background-color:", ";border-radius:", ";overflow:hidden;flex-shrink:0;"], getSizeToken(TOKENS.HEIGHT), getSizeToken(TOKENS.WIDTH), function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.backgroundCountryFlag;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.borderRadiusSmall;
});
StyledCountryFlag.defaultProps = {
  theme: defaultTheme
};
export var StyledImage = styled.img.attrs(function (_ref5) {
  var theme = _ref5.theme,
      size = _ref5.size,
      code = _ref5.code;
  var width = parseInt(getSizeToken(TOKENS.WIDTH)({
    theme: theme,
    size: size
  }), 10);
  return {
    src: "".concat(baseURL, "/flags/").concat(width, "x0/flag-").concat(code.toLowerCase(), ".jpg"),
    srcSet: "".concat(baseURL, "/flags/").concat(width * 2, "x0/flag-").concat(code.toLowerCase(), ".jpg 2x")
  };
}).withConfig({
  displayName: "CountryFlag__StyledImage",
  componentId: "h98fwe-1"
})(["display:block;height:100%;width:100%;flex-shrink:0;"]);
StyledImage.defaultProps = {
  theme: defaultTheme
};
var StyledShadow = styled.div.withConfig({
  displayName: "CountryFlag__StyledShadow",
  componentId: "h98fwe-2"
})(["position:absolute;display:block;height:100%;width:100%;top:0;right:0;bottom:0;left:0;box-shadow:inset 0 0 0 1px ", ";border-radius:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return convertHexToRgba(theme.orbit.paletteInkNormal, 10);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.orbit.borderRadiusSmall;
});
StyledShadow.defaultProps = {
  theme: defaultTheme
};
export function getCountryProps(code, name) {
  var codeNormalized = code ? code.toUpperCase().replace("-", "_") : "ANYWHERE";
  var countryCodeExists = codeNormalized in CODES;
  warning(countryCodeExists, "Country code not supported: %s", code);
  var countryCode = countryCodeExists ? CODES[codeNormalized] : CODES.ANYWHERE;
  var countryName = countryCode === CODES.ANYWHERE && !name ? "Anywhere" : name;
  return {
    code: countryCode,
    name: countryName
  };
}

var CountryFlag = function CountryFlag(_ref) {
  var dataTest = _ref.dataTest,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? SIZES.MEDIUM : _ref$size,
      props = _objectWithoutProperties(_ref, ["dataTest", "size"]);

  var _getCountryProps = getCountryProps(props.code, props.name),
      code = _getCountryProps.code,
      name = _getCountryProps.name;

  return React.createElement(StyledCountryFlag, {
    size: size
  }, React.createElement(StyledImage, {
    key: code,
    alt: name,
    title: name,
    code: code,
    "data-test": dataTest,
    size: size
  }), React.createElement(StyledShadow, null));
};

export default CountryFlag;